<!-- Colores (app web vieja) -->
<div class="subgrupo">
  <h2>Colores</h2>
  <div
    class="row justify-start align-center gap-3"
    [formGroup]="configuracion"
  >
    <!-- Color del Menú -->
    <mat-form-field style="width: 100%">
      <mat-label>Color del Menú</mat-label>
      <input matInput readonly formControlName="colorMenu" />
      <ngx-colors
        matSuffix
        ngx-colors-trigger
        formControlName="colorMenu"
        (change)="onColorChange($event, 'colorMenu')"
      />
    </mat-form-field>
    <!-- Color del Menú Inferior -->
    <mat-form-field style="width: 100%">
      <mat-label>Color del Menú Inferior</mat-label>
      <input
        matInput
        readonly
        formControlName="colorMenuInferior"
      />
      <ngx-colors
        class="suffix"
        matSuffix
        ngx-colors-trigger
        formControlName="colorMenuInferior"
        (change)="onColorChange($event, 'colorMenuInferior')"
      />
    </mat-form-field>
    <!-- Color del Fondo del Botón Inferior -->
    <mat-form-field style="width: 100%">
      <mat-label>Color del Fondo del Botón Inferior</mat-label>
      <input
        matInput
        readonly
        formControlName="colorFondoBotonInferior"
      />
      <ngx-colors
        class="suffix"
        matSuffix
        ngx-colors-trigger
        formControlName="colorFondoBotonInferior"
        (change)="onColorChange($event, 'colorFondoBotonInferior')"
      />
    </mat-form-field>
    <!-- Color del Ícono del Botón Inferior -->
    <mat-form-field style="width: 100%">
      <mat-label>Color del Ícono del Botón Inferior</mat-label>
      <input
        matInput
        readonly
        formControlName="colorIconoBotonInferior"
      />
      <ngx-colors
        class="suffix"
        matSuffix
        ngx-colors-trigger
        formControlName="colorIconoBotonInferior"
        (change)="onColorChange($event, 'colorIconoBotonInferior')"
      />
    </mat-form-field>
    <!-- Color del Botón Instalar -->
    <mat-form-field style="width: 100%">
      <mat-label>Color del Botón Instalar</mat-label>
      <input matInput readonly formControlName="colorInstalar" />
      <ngx-colors
        class="suffix"
        matSuffix
        ngx-colors-trigger
        formControlName="colorInstalar"
        (change)="onColorChange($event, 'colorInstalar')"
      />
    </mat-form-field>
    <mat-form-field style="width: 100%">
      <mat-label>Color Sidenav Inferior</mat-label>
      <input matInput readonly formControlName="colorNavInferior" />
      <ngx-colors
        class="suffix"
        matSuffix
        ngx-colors-trigger
        formControlName="colorNavInferior"
        (change)="onColorChange($event, 'colorNavInferior')"
      />
    </mat-form-field>
    <mat-form-field style="width: 100%">
      <mat-label>Color Sidenav Superior</mat-label>
      <input matInput readonly formControlName="colorNavSuperior" />
      <ngx-colors
        class="suffix"
        matSuffix
        ngx-colors-trigger
        formControlName="colorNavSuperior"
        (change)="onColorChange($event, 'colorNavSuperior')"
      />
    </mat-form-field>
  </div>
</div>

<!-- Imágenes "Push" (botón apretado): solo las usa la app web vieja; la nativa no las lee. -->
<div class="subgrupo">
  <h2>Imágenes de botón apretado</h2>
  <div class="row-wrap justify-start align-center gap-15px">
    <app-upload-image
      [disabled]="!nombresValido()"
      [formulario]="formulario"
      [formGroup]="imagenes"
      [controlName]="'sirenaPush'"
      [hint]="'288×288 px (1:1)'"
      [label]="'Sirena Push'"
    />
    <app-upload-image
      [disabled]="!nombresValido()"
      [formulario]="formulario"
      [formGroup]="imagenes"
      [controlName]="'reflectorPush'"
      [hint]="'288×288 px (1:1)'"
      [label]="'Reflector Push'"
    />
    <app-upload-image
      [disabled]="!nombresValido()"
      [formulario]="formulario"
      [formGroup]="imagenes"
      [controlName]="'adelantePush'"
      [hint]="'1080×216 px'"
      [label]="'Adelante Push'"
    />
    <app-upload-image
      [disabled]="!nombresValido()"
      [formulario]="formulario"
      [formGroup]="imagenes"
      [controlName]="'atrasPush'"
      [hint]="'1080×216 px'"
      [label]="'Atrás Push'"
    />
  </div>
</div>
